import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

const RefundPolicy = () => {
  return (
    <div className="refund-policy">
      <Helmet>
        <title>Refund Policy - Topup Connect</title>
        <meta
          name="description"
          content="Refund policy of Topup Connect operated by CHOTTU TELECOM for recharge and bill payment services"
        />
      </Helmet>

      <h1>Refund Policy</h1>
      <p className="effective-date">Effective Date: 01.01.2025</p>

      <section className="policy-section">
        <h2>Overview</h2>
        <p>
          This Refund Policy applies to all services offered on the Topup
          Connect platform, which is owned and operated by{" "}
          <strong>CHOTTU TELECOM</strong>. By using our services, you agree to
          the terms outlined below.
        </p>
      </section>

      <section className="policy-section">
        <h2>Topup Connect Responsibility for Refunds</h2>

        <div className="policy-point">
          <h3>1. Failed Transactions</h3>
          <p>
            If a recharge, bill payment, or other transaction fails due to a
            technical error on our side, and the amount is deducted from your
            payment method, we will initiate a refund after confirmation from
            the payment gateway or service provider.
          </p>
          <p>
            Refunds will be processed to your original payment method within{" "}
            <strong>7–14 working days</strong>. Any gateway charges, taxes, or
            fees applied by third parties will not be refundable.
          </p>
        </div>

        <div className="policy-point">
          <h3>2. Service Not Delivered</h3>
          <p>
            If you have received a successful payment confirmation but did not
            receive the service (such as recharge or bill clearance), you must
            report the issue to <strong>support@topupconnect.in</strong> within
            48 hours.
          </p>
          <p>
            If, after investigation, the failure is attributed to our system or
            service integration, a full refund (excluding charges) will be
            processed.
          </p>
        </div>
      </section>

      <section className="policy-section">
        <h2>Topup Connect Not Responsible for Refunds</h2>

        <div className="policy-point">
          <h3>1. External Failures</h3>
          <p>
            We are not responsible for transaction failures caused by
            third-party systems or external factors, including:
          </p>
          <ul>
            <li>Mobile network or internet issues</li>
            <li>Power outages or device failures</li>
            <li>Bank server downtime or payment gateway errors</li>
            <li>Delays from telecom or utility providers</li>
          </ul>
        </div>

        <div className="policy-point">
          <h3>2. Completed Transactions</h3>
          <p>
            All successful transactions are final. Once a recharge or bill
            payment is successfully processed and confirmed, no refund or
            cancellation will be allowed.
          </p>
        </div>

        <div className="policy-point">
          <h3>3. Incorrect Details Provided by User</h3>
          <p>Refunds will not be provided in the following cases:</p>
          <ul>
            <li>Incorrect mobile or account number entered</li>
            <li>Wrong operator or biller selection</li>
            <li>Incorrect payment details provided</li>
          </ul>
          <p>
            Users are advised to carefully verify all details before proceeding
            with payment.
          </p>
        </div>
      </section>

      <section className="contact-section">
        <h2>Refund Request Process</h2>
        <p>
          To initiate a refund request, email us at{" "}
          <strong>support@topupconnect.in</strong> with the following:
        </p>
        <ul>
          <li>Transaction ID or Order Number</li>
          <li>Payment method used and reference ID</li>
          <li>Screenshot or payment receipt (if available)</li>
          <li>Brief description of the issue</li>
        </ul>
        <p>
          Our support team will respond within <strong>3–5 working days</strong>
          . If eligible, the refund will be initiated to your original source of
          payment.
        </p>
      </section>

      <section className="policy-section">
        <h2>Chargebacks</h2>
        <p>
          If you initiate a chargeback without contacting us first, we reserve
          the right to suspend or terminate your Topup Connect account. We
          encourage you to reach out for resolution before escalating to your
          payment provider.
        </p>
      </section>

      <section className="policy-section">
        <h2>Policy Updates</h2>
        <p>
          This Refund Policy may be revised from time to time. Changes will be
          posted on our website with an updated effective date. Continued use of
          our services constitutes your acceptance of the modified policy.
        </p>
      </section>

      <section className="policy-section">
        <h2>Legal Owner</h2>
        <p>
          This policy is issued under the legal entity{" "}
          <strong>CHOTTU TELECOM</strong>, which owns and operates the brand{" "}
          <strong>Topup Connect</strong>, located at:
        </p>
        <address>
          Barasat - 1, Kathuria, Malikapur, Duttapukur
          <br />
          Barasat, North 24 Parganas, West Bengal - 700126
          <br />
          Email: support@topupconnect.in
        </address>
      </section>

      <div className="policy-footer">
        <Link to="/">Back to Home</Link>
        <p>By using Topup Connect services, you agree to this Refund Policy.</p>
      </div>
    </div>
  );
};

export default RefundPolicy;
